"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var idm_de_core_frontend_1 = require("@synisys/idm-de-core-frontend");
var idm_message_language_service_client_js_1 = require("@synisys/idm-message-language-service-client-js");
var idm_classifier_service_client_js_1 = require("@synisys/idm-classifier-service-client-js");
var me_kb_http_service_1 = require("./me-kb-http.service");
var idm_de_service_client_js_1 = require("@synisys/idm-de-service-client-js");
var idm_kb_service_client_js_1 = require("@synisys/idm-kb-service-client-js");
var me_service_1 = require("../service/me.service");
var indicator_entity_model_1 = require("../model/indicator-entity.model");
var serialization_helper_1 = require("../helper/serialization-helper");
var zip_1 = require("rxjs/observable/zip");
var operators_1 = require("rxjs/operators");
var of_1 = require("rxjs/observable/of");
var MESerializationService = /** @class */ (function () {
    function MESerializationService(_meKbService, _languageService, _classifierService, _meService) {
        this._meKbService = _meKbService;
        this._languageService = _languageService;
        this._classifierService = _classifierService;
        this._meService = _meService;
        this._entityBuilder = new idm_de_core_frontend_1.EntityBuilder();
    }
    /**
     * Deserializes the collection of entity items.
     * @param {string} systemName - The unique identifier for entity.
     * @param {Array.<any>} entitiesDataObservable - JSON object containing the data of the entity items.
     * @returns {Promise<Array<Promise<Entity>>>} the array of entity objects wrapped in a promise
     */
    MESerializationService.prototype.deserializeEntities = function (systemName, entitiesDataObservable) {
        var _this = this;
        var serviceResponse = new idm_de_service_client_js_1.ServiceResponseDefault();
        var entities = [];
        serviceResponse.setData(entities);
        var entityFieldsObservable = this._meKbService.getMetaFields(systemName);
        var languagesObservable = this._languageService.getInputLanguages();
        return zip_1.zip(entityFieldsObservable, entitiesDataObservable, languagesObservable).pipe(operators_1.mergeMap(function (data) {
            var entityFields = data[0];
            var entitiesData = data[1];
            var languages = data[2];
            serviceResponse.setMeta(serialization_helper_1.deserializeMeta(entitiesData.meta));
            (entitiesData.data).forEach(function (entityData) {
                var entity = _this._entityBuilder.createEntity(indicator_entity_model_1.IndicatorEntity, entityFields);
                entities.push(entity);
                idm_de_core_frontend_1.deserializeSimpleFields(entityFields, languages, entity, entityData);
            });
            return _this.deserializeEntityCompoundFields(entityFields, entities, systemName);
        }), operators_1.mergeMap(function (data) {
            return of_1.of(serviceResponse);
        }));
    };
    /**
     * Deserializes a single entity item.
     * @param {string} systemName - The unique identifier for entity.
     * @param {any} entityDataObservable - JSON object containing data for a single entity item.
     * @param {Entity} entity
     * @param {Array<any>} entityFields
     * @returns {Promise<Entity>} entity object wrapped in a promise
     */
    MESerializationService.prototype.deserializeEntity = function (systemName, entityDataObservable, entity, entityFields) {
        var _this = this;
        return entityDataObservable.pipe(operators_1.mergeMap(function (data) {
            var entityData = data.data || data;
            var languagesObservable = _this._languageService.getInputLanguages();
            return languagesObservable.pipe(operators_1.map(function (languages) {
                return idm_de_core_frontend_1.deserializeSimpleFields(entityFields, languages, entity, entityData);
            }));
        }), operators_1.mergeMap(function (deserializedEntity) {
            return _this.deserializeEntityCompoundFields(entityFields, [deserializedEntity], systemName).pipe(operators_1.mergeMap(function (deserializedEntities) {
                return of_1.of(deserializedEntities[0]);
            }));
        }));
    };
    MESerializationService.prototype.deserializeMainEntity = function (systemName, entityDataObservable, fieldSystemNames) {
        var _this = this;
        var entityFieldsObservable = this._meKbService.getMetaFields(systemName);
        return entityFieldsObservable.pipe(operators_1.mergeMap(function (entityFields) {
            if (fieldSystemNames && fieldSystemNames.length > 0) {
                entityFields =
                    entityFields.filter(function (metafiled) { return fieldSystemNames.indexOf(metafiled.getSystemName()) !== -1; });
            }
            var entity = _this._entityBuilder.createEntity(indicator_entity_model_1.IndicatorEntity, entityFields);
            return _this.deserializeEntity(systemName, entityDataObservable, entity, entityFields);
        }));
    };
    MESerializationService.prototype.deserializeSubEntity = function (systemName, entityDataObservable) {
        var _this = this;
        var entityFieldsObservable = this._meKbService.getMetaFields(systemName);
        return entityFieldsObservable.pipe(operators_1.mergeMap(function (entityFields) {
            var entity = _this._entityBuilder.createEntity(idm_de_service_client_js_1.SubEntity, entityFields);
            return _this.deserializeEntity(systemName, entityDataObservable, entity, entityFields);
        }));
    };
    MESerializationService.prototype.deserializeMainEntityWithMeta = function (systemName, entityData) {
        var _this = this;
        var serviceResponse = new idm_de_service_client_js_1.ServiceResponseDefault();
        var entityFields;
        return this._meKbService.getMetaFields(systemName).pipe(operators_1.mergeMap(function (data) {
            entityFields = data;
            serviceResponse.setMeta(serialization_helper_1.deserializeMeta(entityData.meta));
            var entity = _this._entityBuilder.createEntity(indicator_entity_model_1.IndicatorEntity, entityFields);
            serviceResponse.setData(entity);
            var languagesObservable = _this._languageService.getInputLanguages();
            return languagesObservable.pipe(operators_1.map(function (languages) { return idm_de_core_frontend_1.deserializeSimpleFields(entityFields, languages, entity, entityData.data); }));
        }), operators_1.mergeMap(function (entity) {
            return _this.deserializeEntityCompoundFields(entityFields, [entity], systemName);
        }), operators_1.mergeMap(function (data) {
            return of_1.of(serviceResponse);
        }));
    };
    /**
     * Serializes the entity object.
     * @param {string} systemName - The unique identifier for the entity.
     * @param {Entity} entity - Entity object to be serialized.
     * @returns {any} the serialized entity
     */
    MESerializationService.prototype.serializeEntity = function (systemName, entity) {
        var _this = this;
        var entityData = {};
        var entityFields;
        return this._meKbService.getMetaFields(systemName).pipe(operators_1.mergeMap(function (categoryFields) {
            entityFields = categoryFields;
            var entityFieldsObservables = entityFields.map(function (field) {
                var fieldName = field.getSystemName();
                var fieldType = field.getType();
                var fieldValue = entity.getProperty(fieldName).value;
                if (fieldType === idm_kb_service_client_js_1.MetaFieldType.SUB_ENTITY) {
                    return fieldValue.length === 0 ? of_1.of(fieldValue) :
                        _this.serializeSubEntities(field.getCompoundCategorySystemName(), fieldValue);
                }
                else if (fieldType === idm_kb_service_client_js_1.MetaFieldType.MAIN_ENTITY) {
                    return fieldValue === null ? of_1.of(null) : of_1.of(fieldValue.getInstanceId());
                }
                else {
                    var languagesObservable = _this._languageService.getInputLanguages();
                    return languagesObservable.pipe(operators_1.map(function (languages) { return idm_de_core_frontend_1.serializeSimpleField(field, fieldValue, languages); }));
                }
            });
            return zip_1.zip.apply(void 0, entityFieldsObservables);
        }), operators_1.map(function (entityFieldsData) {
            entityFields.forEach(function (field, index) {
                entityData[field.getSystemName()] = entityFieldsData[index];
            });
            return entityData;
        }));
    };
    /**
     * Serializes the list of SubEntity objects.
     * @param {string} systemName - The unique identifier for the subEntity.
     * @param {Array<SubEntity>} subEntities - List of SubEntities to be serialized.
     * @returns {any} the serialized subEntities
     */
    MESerializationService.prototype.serializeSubEntities = function (systemName, subEntities) {
        var _this = this;
        var subEntitiesObservables = subEntities.map(function (subEntity) {
            return _this.serializeEntity(systemName, subEntity);
        });
        return zip_1.zip.apply(void 0, subEntitiesObservables);
    };
    MESerializationService.prototype.deserializeSubEntities = function (systemName, entitiesData) {
        var _this = this;
        var entityFieldsObservable = this._meKbService.getMetaFields(systemName);
        var languagesObservable = this._languageService.getInputLanguages();
        return zip_1.zip(entityFieldsObservable, languagesObservable).pipe(operators_1.mergeMap(function (data) {
            var entityFields = data[0];
            var languages = data[1];
            var partiallyDeserializedEntities = entitiesData.map(function (entityData) {
                var entity = _this._entityBuilder.createEntity(idm_de_service_client_js_1.SubEntity, entityFields);
                return idm_de_core_frontend_1.deserializeSimpleFields(entityFields, languages, entity, entityData);
            });
            return _this.deserializeEntityCompoundFields(entityFields, partiallyDeserializedEntities, systemName);
        }));
    };
    MESerializationService.prototype.deserializeEntityCompoundFields = function (entityFields, entities, categorySystemName) {
        var _this = this;
        var entityCompoundFields = entityFields.filter(serialization_helper_1.isCompoundField).filter(function (field) {
            return entities.some(function (entity) {
                return serialization_helper_1.isFieldValueNotEmpty(field, entity);
            });
        });
        if (entityCompoundFields.length > 0) {
            var entityNonSimpleFieldObservables = entityCompoundFields
                .map(function (field) {
                return _this.deserializeCompoundField(field, entities, categorySystemName);
            });
            return zip_1.zip.apply(void 0, entityNonSimpleFieldObservables).pipe(operators_1.map(function (fieldValues) {
                entityCompoundFields.forEach(function (field, index) {
                    entities.forEach(function (entity, entityIndex) {
                        if (fieldValues[index][entityIndex]) {
                            entities[entityIndex].getProperty(field.getSystemName()).value = fieldValues[index][entityIndex];
                        }
                    });
                });
                return entities;
            }));
        }
        else {
            return of_1.of(entities);
        }
    };
    MESerializationService.prototype.deserializeCompoundField = function (field, entities, categorySystemName) {
        var _this = this;
        var fieldType = field.getType();
        switch (fieldType) {
            case idm_kb_service_client_js_1.MetaFieldType.CLASSIFIER:
            case idm_kb_service_client_js_1.MetaFieldType.WORKFLOW_STATE: {
                var classifierIds_1 = entities.map(function (entity) {
                    return entity.getProperty(field.getSystemName()).value;
                });
                return this._classifierService.loadClassifiersByIds(field.getCompoundCategorySystemName(), classifierIds_1.filter(this.uniqueFilter), true).pipe(operators_1.mergeMap(function (classifiersResponse) {
                    var classifiersMap = new Map();
                    classifiersResponse.getData().forEach(function (classifier) {
                        classifiersMap.set(classifier.getId(), classifier);
                    });
                    return of_1.of(classifierIds_1.map(function (classifierId) {
                        return classifiersMap.get(classifierId);
                    }));
                }));
            }
            case idm_kb_service_client_js_1.MetaFieldType.MULTI_SELECT: {
                return zip_1.zip.apply(void 0, entities.map(function (entity) {
                    return _this._classifierService.loadClassifiersByIds(field.getCompoundCategorySystemName(), entity.getProperty(field.getSystemName()).value, true).pipe(operators_1.mergeMap(function (classifiersResponse) { return of_1.of(classifiersResponse.getData()); }));
                }));
            }
            case idm_kb_service_client_js_1.MetaFieldType.MAIN_ENTITY: {
                return zip_1.zip.apply(void 0, entities.map(function (entity) {
                    return _this._meKbService.getMainEntityMetaFields(categorySystemName, field.getSystemName())
                        .mergeMap(function (metafields) {
                        var entityInstanceId = entity.getProperty(field.getSystemName()).value;
                        if (!entityInstanceId) {
                            return of_1.of(null);
                        }
                        return _this._meService.loadEntityByInstanceId(field.getCompoundCategorySystemName(), entityInstanceId, undefined, metafields.map(function (metafield) { return metafield.getSystemName(); }));
                    });
                }));
            }
            case idm_kb_service_client_js_1.MetaFieldType.SUB_ENTITY: {
                return zip_1.zip.apply(void 0, entities.map(function (entity) {
                    return _this.deserializeSubEntities(field.getCompoundCategorySystemName(), entity.getProperty(field.getSystemName()).value);
                }));
            }
            default: {
                throw new Error("Illegal field type " + field.getType() + " was provided.");
            }
        }
    };
    MESerializationService.prototype.extractActionDtos = function (actions) {
        var actionDtos = [];
        for (var _i = 0, actions_1 = actions; _i < actions_1.length; _i++) {
            var item = actions_1[_i];
            actionDtos.push(serialization_helper_1.extractActionDto(item));
        }
        return of_1.of(actionDtos);
    };
    MESerializationService.prototype.uniqueFilter = function (value, index, self) {
        return self.indexOf(value) === index;
    };
    MESerializationService = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [me_kb_http_service_1.MEKbHttpService,
            idm_message_language_service_client_js_1.LanguageService,
            idm_classifier_service_client_js_1.ClassifierService,
            me_service_1.MEService])
    ], MESerializationService);
    return MESerializationService;
}());
exports.MESerializationService = MESerializationService;
//# sourceMappingURL=me-serialization.service.js.map